import { fetchWithCache, getCachedData } from "../services/apiService";

export const getAllPromotions = async () => {
  // Return cached data immediately if available
  const cached = getCachedData("/api/promotion/all", {});

  try {
    const data = await fetchWithCache(
      "/api/promotion/all",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    return Array.isArray(data) ? data : [];
  } catch (error) {
    return cached || [];
  }
};
